import { px } from '../../utils/selectorsUtils'
import { createCssCompNode } from '../cssCompNode'
import { Component } from '@wix/thunderbolt-becky-types/dist'
import { FeatureRefs } from '../cssFeatures.types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { sizeToString } from '@wix/thunderbolt-becky-root'

export const placeholder = createCssCompNode('compsMeasuresCss', 'placeholder', {
	getDependencies: (component: Component, refs: FeatureRefs<'compsMeasuresCss'>) => ({
		isOneDocMigrated: envRefs.isOneDocMigrated,
		compSingleLayout: refs.compSingleLayout(component),
	}),
	toViewItem: (component, deps) => {
		const { compSingleLayout, isOneDocMigrated } = deps

		if (isOneDocMigrated) {
			if (compSingleLayout?.itemLayout?.type === 'FixedPositionItemLayout') {
				const placeholderHeight =
					compSingleLayout?.componentLayout?.minHeight || compSingleLayout?.componentLayout?.height
				return { height: sizeToString(placeholderHeight) }
			}
		} else {
			if (
				component.layout.fixedPosition &&
				(component.componentType === 'FooterContainer' || component.componentType === 'HeaderContainer')
			) {
				return { height: px(component.layout.height) }
			}
		}

		return null
	},
})
